import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrManager } from "ng6-toastr-notifications";
import { DatePipe } from '@angular/common';

@Component({
  selector: "app-buckets",
  templateUrl: "./buckets.component.html",
  styleUrls: ["./buckets.component.css"]
})
export class BucketsComponent implements OnInit {
  public bucketData = {
    bucketname: [],
    region: localStorage.getItem("region")
  };
  public data = [];
  public objectData;
  public cred = {
    region: localStorage.getItem("region")
  };
  public submitted: boolean = false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      rowCallback: (row: Node, data: Object, index: number) => {
        $("input[type='checkbox']", row).unbind("click");
        $("input[type='checkbox']", row).bind("click", () => {
          const index = this.bucketData.bucketname.indexOf(data[1]);
          if ($("input[type='checkbox']", row).is(":checked")) {
            if (index === -1) {
              this.bucketData.bucketname.push(data[1]);
              console.log(this.bucketData.bucketname);
            }
          } else {
            this.bucketData.bucketname.splice(index, 1);
            console.log(this.bucketData.bucketname);
          }
          console.log(this.bucketData.bucketname.length);
          if (this.bucketData.bucketname.length > 1) {
            this.submitted = true;
          } else if (this.bucketData.bucketname.length <= 1) {
            this.submitted = false;
          }
        });

        return row;
      }
    };
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
    }, 2000);
    this.getBucketList();
  }

  getBucketList() {
    return this.dataService
      .getBucketList()
      .subscribe((Data: any) => {
        console.log(Data);
        if (Data.Status == "Error") {
          // alert(Data.Error.message);
          this.toastr.errorToastr(Data.Error.message, "oops!");
        } else {
          this.data = Data.Data.Buckets;
          this.dtTrigger.next();
        }
      });
  }

  getDate( date){
    // console.log(this.datePipe.transform('2018-10-05T07:54:18.881Z'	, 'medium'));
    // console.log(date)
    return this.datePipe.transform(date, 'medium')
  }

  showS3Object(bucket) {
    this.router.navigate([
      "/buckets/show-object",
      {
        bucketname: bucket,
        maxkey: 500,
        region: localStorage.getItem("region")
      }
    ]);
  }

  deleteSingleBucket(bucket) {
    this.bucketData.bucketname=[]
    if (this.bucketData.bucketname.length == 0) {
      this.bucketData.bucketname.push(bucket);
    }
    if (this.bucketData.bucketname.length == 1) {
      this.deleteBucket();
    }
  }

  deleteBucket() {
    console.log(this.bucketData);

    var sure = confirm("Are you sure,Do you want to delete?");
    if (sure == true) {
      this.dataService.deleteBucket(this.bucketData).subscribe((Data: any) => {
        if (typeof Data == "string") {
          var newData = JSON.parse(Data);
        } else {
          var newData = Data;
        }
        console.log(newData);
        if (newData.Status == "Error") {
          console.log(newData.Error.message);
          // alert(newData.Error.message);
          this.toastr.errorToastr(newData.Error.message, "oops!");
        } else if (newData.Status == "Success") {
          // alert("Bucket Deleted Successfully");
          this.toastr.successToastr("Bucket Deleted Successfully", "Success!");
          location.reload();
        }
      });
    } else {
      console.log("Cancel");
    }
  }
}
